import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const statusConfig = {
  "Pendiente": "bg-secondary text-secondary-foreground",
  "Contactado": "bg-chart-5/20 text-foreground",
  "Promesa de Pago": "bg-warning/20 text-warning",
  "Abonado": "bg-chart-3/20 text-chart-3",
  "Pagado": "bg-success/20 text-success",
  "Disputado": "bg-destructive/20 text-destructive",
  "Pendiente Verificación Humana": "bg-primary/10 text-primary",
};

export default function StatusBadge({ status, className }) {
  const s = status || "Pendiente";
  return (
    <Badge
      variant="outline"
      data-testid={`status-badge-${s.toLowerCase().replace(/\s+/g, "-")}`}
      className={cn("rounded-full font-normal border-border", statusConfig[s], className)}
    >
      {s}
    </Badge>
  );
}
